import { Component, Host, h, Element } from '@stencil/core';

export interface AhaBreadcrumb extends HTMLAhaBreadcrumbElement {}

/**
 * Custom breadcrumb component.
 * @slot default - Contents of the default slot.
 */
@Component({
  tag: 'aha-breadcrumb',
  styleUrl: 'aha-breadcrumb.css',
  shadow: true,
})
export class AhaBreadcrumb {
  @Element() host!: HTMLAhaBreadcrumbElement;

  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
